import React, { Component } from 'react';
import { Container, Row, Col } from 'react-bootstrap';
import getConfig from 'next/config';
const { serverRuntimeConfig, publicRuntimeConfig } = getConfig();
import ScrollAnimation from 'react-wow';
import Link from 'next/link';

export default class index extends Component {
    render() {
        return (
            <ScrollAnimation animation='bounceInLeft'>
                <section className="mt-4 mb-4 pt-4 pb-4">
                    <Container>
                        <Row>
                            <Col className="text-center" md>
                                <img src={`${publicRuntimeConfig.staticFolder}/images/dev-group.png`} alt="dev-group" className="mt-sm-3 dfdf-width" />
                            </Col>
                            <Col>
                                <div className="mt-5">
                                    <div className="count">03</div>
                                    <div className="talk-content count-sd pl-3">What we do?</div>
                                </div>
                                <div className="main-heading-home pt-sm-2">Software Engineering</div>
                                <div className="main-content pt-sm-1">
                                    Technology can help us accomplish anything. What really matters is tech that works.
                                    </div>

                                <Link href="/devalopment-services" as="/Software-Engineering">
                                        <div className="talk-content explore mt-sm-5">Explore
                                        <img src={`${publicRuntimeConfig.staticFolder}/images/Path.svg`} alt="Path" className="ml-sm-1" />
                                        </div>
                                </Link>
                            </Col>
                        </Row>
                    </Container>
                </section>
                <style>
                    {
                        `
                        body{
                            overflow-x: hidden
                        }
                        `
                    }
                </style>
            </ScrollAnimation>
        )
    }
}
